
import styled, { css } from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';


export const Item = styled.div`
    display: flex; 
    flex-direction: column;
    align-items: center;


    `


export const Icon = styled.div`
   
    `
export const ItemName = styled.h3`
    color: #faf9f9;
       
    `
export const ItemContent = styled.p`
    color:#faf9f9;
    

    `